/**
 * DiCon Incident Service API
 * API used by DiCon, LiOn and Buefo.
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: dienstleistung@netze-bw.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Incident data for the Lion CSV export
 */
export interface IncidentLionCsvExportTO { 
    /**
     * City of the incident
     */
    Stadt: string;
    /**
     * Street and house number of the incident
     */
    Adresse: string;
    /**
     * Reported timestamp
     */
    Zeitpunkt: string;
    /**
     * Symptoms of the incident
     */
    Symptome: string;
    /**
     * Reporter type of the incident
     */
    Melder: string;
    /**
     * Other symptoms of the incident
     */
    Anmerkungen_Symptome?: string;
    /**
     * Remarks of the commune
     */
    Anmerkungen_der_Kommune?: string;
    /**
     * Remarks of the citizen
     */
    Anmerkungen_des_Brgers?: string;
    /**
     * Lighting number
     */
    Leuchtstelle?: string;
    /**
     * Control cabinet number
     */
    Schaltstelle?: string;
    /**
     * Current incident status
     */
    Bearbeitungsstatus: string;
}

